<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="消费日期">
          <date-range-picker :start.sync="searchItem.start_at" :end.sync="searchItem.end_at" type="before" width="230px"/>
        </el-form-item>
        <el-form-item label="所属商家">
          <el-input v-model.trim="searchItem.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="searchItem.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="账单状态">
          <el-select v-model="searchItem.status" clearable>
            <el-option v-for="item in billStatus" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单号">
          <el-input v-model.trim="searchItem.order_no" clearable style="width: 220px"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="searchItem.method" clearable>
            <el-option v-for="item in billMethod" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="amount" slot-scope="scope">
          <span>{{convertYuan(scope.row.amount)}}</span>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import DateRangePicker from "@view/components/date/DateRangePicker"
  import {billUserAction, billMethod, billStatus} from "@utils/formatList"
  export default {
    name: "userConsume",
    mixins: [PagingData],
    components: {Statistics,DateRangePicker},
    data() {
      return {
        billStatus,
        billMethod,
        // 查询项
        searchItem: {
          start_at: "",
          end_at: "",
          name: "",
          mobile: "",
          status: "",
          order_no: "",
          method: "",
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "总记录", count: 0},
          {name: "收款(￥)", count: 0, color: "#0cca8e", decimals: 2},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "所属商家", property: "shopName"},
            {label: "账单号", property: "order_no", width: 180},
            {label: "上网账号", property: "user_info.username"},
            {label: "充值类型", property: "action", format: billUserAction},
            {label: "套餐名称", property: "package_info.name"},
            {label: "充值时间", property: "payment_at"},
            {label: "支付金额(￥)", property: "amount"},
            {label: "支付方式", property: "method", format: billMethod},
            {label: "账单状态", property: "status",format: billStatus},
            {label: "描述", property: "describe"},
          ],
        },
      }
    },
    methods: {
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getBillUserConsume(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          let cost = +res.data.cost || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.countList[1].count = +this.convertYuan(cost);
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
